import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=a7f20cf0&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7f20cf0')) {
      api.createRecord('a7f20cf0', component.options)
    } else {
      api.reload('a7f20cf0', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=a7f20cf0&", function () {
      api.rerender('a7f20cf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Tcv8X3B3Mr0t/JS/ImageCarousel.vue"
export default component.exports